import React from 'react';
import { makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import type { HeaderProps } from '../../types/layout';
import { UserProfileMenu } from './UserProfileMenu';

const useStyles = makeStyles({
  header: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    ...shorthands.padding('0', '12px'),
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('12px'),
  },
  headerCompact: {
    ...shorthands.padding('0', '4px'),
  },
  headerContentCompact: {
    ...shorthands.gap('8px'),
  },
});

export const Header: React.FC<HeaderProps> = ({ compact = false }) => {
  const styles = useStyles();

  return (
      <header className={mergeClasses(styles.header, compact && styles.headerCompact)} data-testid="app-header">
        <div className={mergeClasses(styles.headerContent, compact && styles.headerContentCompact)} data-testid="header-actions">
          <UserProfileMenu compact={compact} />
        </div>
      </header>
  );
};